import { Component, HostListener} from '@angular/core';
import { IKnavNavItem, IKHeaderLogo } from 'ng-k-header';
import { NavigationEnd, Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { OauthPlusService } from './services/oauth-plus.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SharedService } from './services/shared.service';
import { KModalService } from 'ng-k-modal';
import { PasswordService } from './shared/password-update/password.service';
import { TimeoutService } from './services/timeout.service'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Disease Tools';
  public navItems!: IKnavNavItem[];
  public isLoaderOn = true;

  public logo!: IKHeaderLogo;
  public showUserOptions: boolean = false;
  public showSettingsOptions : boolean = false;


  public isLoggedIn: boolean = false;
  public userName = '';
  userIdle: false;

  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    public sharedService: SharedService,
    private oauthService: OAuthService,
    private modalService: KModalService,
    private oauthPlusService: OauthPlusService,
    private passwordService: PasswordService,
    private timeoutService: TimeoutService,

  ) {
    this.initialRouterCheck();
    this.configureOAuth();
  }

  @HostListener('document:click', ['$event'])
  closePopup(event: any) {
    this.showSettingsOptions = false;
    this.showUserOptions = false;

  }

  ngOnInit() {
    // this.activityTracker.startTracking();
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url === '/' || e.url === '/claims') {
          const logoHeader = document.getElementById('logoHeader');
          if (logoHeader != null) {
            logoHeader.classList.remove('clickable');
          }
        } else {
          const logoHeader = document.getElementById('logoHeader');
          if (logoHeader != null) {
            logoHeader.classList.add('clickable');
          }
        }
      }
    });
    this.navItems = [
      {
        label: 'Claims',
        routerLink: ['/claims'],
      },
      {
        label: 'Insights',
        routerLink: ['/insights'],
      },
    ];

    this.logo = {
      type: 'text',
      value: 'IQ Platform',
      routerLink: ['/claims'],
    };
  }

  configureOAuth() {
    this.oauthPlusService.configure();
    this.oauthPlusService.$whenUserLoaded.subscribe((value: boolean) => this.isLoggedIn = value);
    this.sharedService.userDetails$.subscribe((data: any) => {
      if (data) {
        this.userName = (data.given_name ? data.given_name : '') + (data.family_name ? ' ' + data.family_name : '');
      }
    });
  }

  // closeModal() {
  //   this.modalService.setIsOpen('renewTokenFailed', false);
  //   this.oauthService.silentRefresh();
  //   // this.oauthPlusService.configure();
  // }

  redirectToLogin() {
    if(this.modalService.getIsOpen('renewTokenFailed')){
      this.modalService.setIsOpen('renewTokenFailed',false)
    }
    this.oauthPlusService.setObservablesOntoken();
    this.sharedService.setOnUserLogged(false)
    this.oauthService.logOut();
    this.router.navigateByUrl('/');
  }

  showButton($event: any) {
    $event.stopPropagation();
    this.showUserOptions = true;

  }

  leaveButton($event: any) {
    this.showUserOptions = false;
  }

  initialRouterCheck() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        let currentUrl: string = event.url;
        this.invokeTimeout(currentUrl);
      }
    });
  }

  invokeTimeout(currentUrl: string) {
    this.timeoutService.timeoutInit({ init: true });
  }

  logout() {
    this.showUserOptions = false;
    this.oauthPlusService.setObservablesOntoken();
    setTimeout(() => this.sharedService.setOnUserLogged(false), 20)
    this.oauthService.logOut();
  }

  changePassword(): void {
    this.showUserOptions = false;
    this.passwordService.showChangePassword();
  }

}
